module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/suez-white.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Service Complet")]), _vm._v(" "), _c('h3', [_vm._v("Backoffice")]), _vm._v(" "), _c('form', {
    staticClass: "ui form loginForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "placeholder": "Utilisateur",
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('message', {
    attrs: {
      "obj": _vm.login.message,
      "hide-mutation-type": "CLEAR_LOGIN_MESSAGE"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "forgot-password",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v(" > Mot de passe oublié ? ")]), _vm._v(" "), (_vm.login.loggedIn) ? _c('div', {
    staticClass: "callout callout-success"
  }, [_c('p', [_vm._v("Bienvenue !")])]) : _vm._e(), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg',
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("S'identifier\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc6d36f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1882
// module chunks = 2